export enum VerificationCodeProviderType {
    Sms = "Sms",
    PhoneCall = "PhoneCall",
    Email = "Email"
}
